import * as React from "react";
import { useSelector } from "react-redux";

import { DesignToken, Text } from "@livechat/design-system-react-components";

import { formatPrice } from "helpers/subscription";
import { selectIsPastDue } from "store/entities/license";
import { IRecurlyCoupon } from "store/entities/recurly";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

import SubscriptionPastDueAlert from "../../components/SubscriptionPastDueAlert";

interface IProps {
  price: number;
  nonViewersCount: number;
  isCanceled: boolean;
  isTaxed: boolean;
  expirationDate: string;
  coupon: IRecurlyCoupon | null;
}

export const PhasePaid: React.FC<IProps> = ({
  price,
  nonViewersCount,
  isCanceled,
  isTaxed,
  expirationDate,
  coupon,
}) => {
  const isPastDuePayment = useSelector(selectIsPastDue);

  return (
    <>
      {isPastDuePayment && <SubscriptionPastDueAlert />}
      <>
        {isCanceled && !isPastDuePayment && (
          <Text customColor={withVar(DesignToken.ActionNegativeDefault)}>
            Your subscription will be canceled on <strong>{expirationDate}</strong>.
          </Text>
        )}
        {!isCanceled && !isPastDuePayment && (
          <Text customColor={withVar(DesignToken.ActionPositiveDefault)}>Your subscription is up and running!</Text>
        )}
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        {coupon?.redemptions?.some?.((item: any) => item.state === "active") && (
          <Text>
            The “<strong>{coupon.code}</strong>” coupon will be applied for your next payment.
          </Text>
        )}
        {!isCanceled && !isPastDuePayment && (
          <Text>
            The charge of{" "}
            <strong>
              {formatPrice(price)}
              {isTaxed && " + applicable tax"}
            </strong>{" "}
            is due on <strong>{expirationDate}</strong>.
          </Text>
        )}
        <Text>
          You have{" "}
          <strong>
            {nonViewersCount} paid {plural(nonViewersCount, "user", "users")}
          </strong>{" "}
          in HelpDesk.
        </Text>
      </>
    </>
  );
};
